import useStyles from './Styles'
import React, { useContext, useEffect } from 'react'
import Provider, { PursuitsPageContext, PursuitsPageContextProvider } from './Provider'
import { Box } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { QuestionBlock, AsyncResponsesLoading } from 'components'
import { IProps } from './Interface'
import { handleEnterKey } from 'utils'

const PursuitsPagePage: React.FC<IProps> = ({ disabled }) => {
  const { state, handlers } = useContext<PursuitsPageContext>(PursuitsPageContextProvider)
  const { passions } = state

  const theme = useTheme()
  const classes = useStyles({})
  const colors = [theme.palette.common.lightPurple, theme.palette.common.lightBlue, theme.palette.common.orange]

  useEffect(() => {
    handlers.handleOnInit()
  }, [])

  return (
    <Box className={classes.root}>
      {passions.map((passion, index) => (
        <Box mb={2} key={index} className={`i-pursue-with-intensity-section-${index + 1}`}>
          <QuestionBlock
            edit={!!state.edit[index] && !disabled}
            color={colors[index]}
            title={{
              questionKey: 'title',
              limit: state.questions?.passions?.rules?.item?.title?.maxLength,
              label: 'What do you pursue with intensity?',
              initialValue: passion.title
            }}
            detail={{
              questionKey: 'detail',
              limit: state.questions?.passions?.rules?.item?.detail?.maxLength,
              label: 'What do you like about it and why does it matter to you?',
              initialValue: passion.detail
            }}
            onSave={() => !disabled && handlers.handleUpdatePursuit()}
            onChange={({ response, questionKey }) => handlers.handleChangePursuit({ index, response, questionKey })}
            onClick={() => handlers.handleSetEdit({ [index]: true })}
            onClickOutside={() => handlers.handleSetEdit({ ...state.edit, [index]: false })}
            onKeyPressDetail={handleEnterKey(() => {
              handlers.handleUpdatePursuit()
              handlers.handleSetEdit({ ...state.edit, [index]: false, [index + 1]: true })
            })}
            onDelete={async () => {
              handlers.handleDeletePursuit(index)
              await handlers.handleUpdatePursuit()
            }}
            disabled={disabled}
          />
        </Box>
      ))}
    </Box>
  )
}

export default (props: IProps) => (
  <Provider {...props}>
    <AsyncResponsesLoading>
      <PursuitsPagePage {...props} />
    </AsyncResponsesLoading>
  </Provider>
)
